import { css } from "@stubhub/broadway-foundation/css";

export const navRowStyle = css({
  display: "flex",
  alignItems: "center",
  width: "full",
  paddingBlock: "primitives.200",
});

export const titleContainerStyle = css({
  flexGrow: 1,
  flexShrink: 1,
  flexBasis: "[0]",
  textAlign: "center",
});
